import { useEffect, useRef, useState } from 'react'
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import './collections-landing.styles.scss';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import CollectionsList from './collections-list.component';
import CollectionsForm from './collections-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';

const CollectionsLandingPage = ({ gameElements, gameData, gameStats, role }) => {

  const membership = useEffectiveMembership();
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [collectionsFromDb, setCollectionsFromDb] = useState({});
  const collectionsRef = useRef();
  const location = useLocation()
  const collectionsListenerRef = useRef();
  const navigate = useNavigate();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager');

  useEffect(() => {
    if (!gameData?.gameName) return;
    changeDocumentTitle(`Collections | Manage ${gameData?.gameName || ''}`);
  }, [gameData?.gameName])

  useEffect(() => {
    if (!gameData || !membership) return;
    checkMembership();
    function checkMembership() {
      const element = 'collections'
      const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
      // console.log(res);

      if (res.disabled) {
        if (!membershipRestrictions) return;
        let message = ''
        const planRest = membershipRestrictions[membership.membership];
        if (res.disabledReason.includes(element)) {
          message = `While using the ${planRest.title}, you are not able to access ${properCase(element)}.`;
        }
        setShowUpgradeModal(message)
      }
    }
  }, [membership, gameData]);

  useEffect(() => {
    if (!gameId) return;
    getGameElementsToManage();
    function getGameElementsToManage() {
      if (isPreview) {
        if (!completeGameElementData) return;
        const previewData = Object.values(completeGameElementData).filter(el => el.type === 'collection');
        collectionsRef.current = {};
        previewData.forEach(collection => {
          collectionsRef.current[collection.id] = collection;
        });
        setCollectionsFromDb(collectionsRef.current);
        return;
      }
      getCollectionFromDb({
        "collection": `games/${gameId}/gameElements`,
        "query1": {
          "key": "type",
          "condition": "==",
          "value": "collection"
        },
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        collectionsRef.current = {
          ...collectionsRef.current,
          ...{ [data.id]: data }
        }
        setCollectionsFromDb(collectionsRef.current);
      }
      function handleListener(data) {
        collectionsListenerRef.current = data;
      }
    }
    return () => {
      if (collectionsListenerRef.current) {
        collectionsListenerRef.current();
        collectionsListenerRef.current = null;
      }
    }
  }, [gameId, isPreview, completeGameElementData])



  return (
    <div className={`collections-landing ${screenSize}`}>
      <div className='g-card collections-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className="g-space-1"></div>
        <div className='card-title'>
          <ImageContainer
            src='/images/icons/collections.png'
            alt='collections icon'
            className='head-icon' />
          Create and Edit Collections
        </div>
        <hr />
        <div className='collections-landing-content'>
          <Routes>
            <Route path='' element={
              <CollectionsList
                gameData={gameData}
                gameElements={gameElements}
                collectionsFromDb={collectionsFromDb}
                role={role} />
            }></Route>
            <Route path='create' element={
              <CollectionsForm
                gameData={gameData}
                gameStats={gameStats}
                gameElements={gameElements}
                collectionsFromDb={collectionsFromDb}
                role={role} />
            }></Route>
            <Route path='edit/:collectionPath' element={
              <CollectionsForm
                gameData={gameData}
                gameStats={gameStats}
                gameElements={gameElements}
                collectionsFromDb={collectionsFromDb}
                role={role} />
            }></Route>
            <Route path="*" element={
              <Navigate replace to="/404" />
            } />
          </Routes>
        </div>
      </div>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default CollectionsLandingPage